"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * The types of aspects can be associated for a single aspect.
 */
exports.AspectTypes = ['topic', 'competence'];
var QuestionLevel;
(function (QuestionLevel) {
    QuestionLevel["easy"] = "easy";
    QuestionLevel["normal"] = "normal";
    QuestionLevel["hard"] = "hard";
})(QuestionLevel = exports.QuestionLevel || (exports.QuestionLevel = {}));
//# sourceMappingURL=strategy.js.map